import { header } from './modules/header';
import { animation } from './modules/animation';
import { anchorScroll } from './modules/anchorScroll';


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
	header();
	animation();
	anchorScroll();

	let resizeTimer;
	let prevWidth = window.innerWidth;

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);

		resizeTimer = setTimeout(() => {
			const currentWidth = window.innerWidth;

			if (currentWidth !== prevWidth) {
			window.location.reload();
			}

			prevWidth = currentWidth;
		}, 300);
	});
});